import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Spinner, Progress } from 'reactstrap';
import Translate, { t } from '../common/Translate';
import Flex from '../common/Display/Flex';
import CarProfileContainer from '../CarProfile/CarProfileContainer';
import ConditionalSelect from '../FormElement/ConditionalSelect';
import Image from '../FormElement/Image';
import Input from '../FormElement/Input';
import RimSize from '../FormElement/RimSize';
import Boolean from '../FormElement/Boolean';
import Display from '../FormElement/Display';
import Select from '../FormElement/Select';
import SelectMultiple from '../FormElement/SelectMultiple';
import useConditionalDisplay from '../../services/Form/useConditionalDisplay';
import MultipleDamage from '../FormElement/MultipleDamage';
import useHide from '../../services/Form/useHide';
import AlertElement from '../FormElement/AlertElement';
import MultiplePhoto from '../FormElement/MultiplePhoto';
import MultipleAnomaly from '../FormElement/MultipleAnomaly';

let lastClic = true; // previous clic was previous question(false) or next question (true) => for the skip question

const QuestionSlide = (props) => {
  const [navIsShown, setterNavIsShown] = useState(true);
  const [navDisable, setterNavDisable] = useState(false);
  const [questionFullScreen] = useState(false);
  const {
    question,
    formId,
    sectionId,
    progress,
    calculateProgress,
    lastQuestion,
    goNextQuestion,
    goPrevQuestion,
    id,
    headerTitle,
    country,
  } = props;
  const elementIds = { formId, sectionId, questionId: question.id };
  const [display] = useConditionalDisplay(question.remove_if, elementIds, question);
  const [hide] = useHide(formId, sectionId, question.id);

  if (country === 'UK' && question.id === 'client_zip') {
    question.type = 'string';
    question.mask = '';
  }

  useEffect(() => {
    calculateProgress();
  }, [question]);

  if (!display || hide === true) {
    if (lastClic) goNextQuestion();
    else goPrevQuestion();
  }

  const setDisableNav = (bool) => {
    if (bool !== navDisable) {
      setterNavDisable(bool);
    }
  };

  const setNavIsShown = (bool) => {
    if (bool !== navIsShown) {
      setterNavIsShown(bool);
    }
  };

  const renderLabel = () => {
    if (question.id === 'vin_picture') {
      return (
        <label className="d-block mb-0 vin-number text-left" htmlFor={id}>
          {question.label}
        </label>
      );
    }
    return (
      <label className="d-block mb-0 text-left" htmlFor={id}>
        <Translate code={question.label} />
      </label>
    );
  };

  const handleGoNext = () => {
    lastClic = true;
    goNextQuestion();
  };
  const handleGoPrev = () => {
    lastClic = false;
    goPrevQuestion();
  };

  const showNav = (navShownStatus) => {
    setterNavIsShown(navShownStatus);
  };

  const renderElement = () => {
    let element;
    switch (question.type) {
      default:
      case 'text':
      case 'string':
      case 'integer':
      case 'number':
      case 'date':
      case 'km':
      case 'textarea':
      case 'dropdowns':
        element = (
          <Container fluid className="my-auto">
            <Input {...props} question={question} autoFocus elementIds={elementIds} setDisableNav={setDisableNav} />
          </Container>
        );
        break;

      case 'boolean':
        element = (
          <Container fluid className="my-auto">
            <Boolean
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'display':
        element = (
          <Container fluid className="my-auto" data-cy="d-flex">
            <Display elementIds={elementIds} question={question} goNextQuestion={handleGoNext} />
          </Container>
        );
        break;

      case 'select_multiple':
        element = (
          <Container fluid className="my-auto">
            <SelectMultiple question={question} elementIds={elementIds} setDisableNav={setDisableNav} />
          </Container>
        );
        break;

      case 'select':
        element = (
          <Container fluid className="my-auto">
            <Select
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'image':
        element = (
          <Container fluid className="my-auto">
            <Image
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'conditional_select':
        element = (
          <Container fluid className="my-auto">
            <ConditionalSelect
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'rim_size':
        element = (
          <Container fluid className="my-auto">
            <RimSize
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'zone_select':
        element = (
          <Container fluid className="mb-auto">
            <CarProfileContainer
              {...props}
              question={question}
              elementIds={elementIds}
              showNav={showNav}
              setDisableNav={setDisableNav}
              goNextQuestion={handleGoNext}
            />
          </Container>
        );
        break;

      case 'multiple_anomaly':
        element = (
          <Container fluid className="my-auto">
            <MultipleAnomaly
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
              setNavIsShown={setNavIsShown}
            />
          </Container>
        );
        break;

      case 'multiple_damages':
        element = (
          <Container fluid className="my-auto">
            <MultipleDamage
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
              setNavIsShown={setNavIsShown}
            />
          </Container>
        );
        break;

      case 'select_alerts':
        element = (
          <Container fluid className="my-auto">
            <AlertElement
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;

      case 'multiple_photos':
        element = (
          <Container fluid className="my-auto">
            <MultiplePhoto
              question={question}
              elementIds={elementIds}
              goNextQuestion={handleGoNext}
              setDisableNav={setDisableNav}
            />
          </Container>
        );
        break;
    }

    return element;
  };

  const renderNav = () => {
    let disabled = false;
    if (question.required && navDisable) {
      disabled = true;
    }

    if (navIsShown) {
      return (
        <div className="footer-sticky-bottom">
          <Row>
            <Col>
              <button type="button" className="btn btn-outline-primary btn-block" onClick={handleGoPrev}>
                <Translate code="return" />
              </button>
            </Col>
            <Col>
              {question.type !== 'post_new_form' && !disabled && (
                <button type="button" className="btn btn-orange btn-block" onClick={handleGoNext} data-cy="myBtn">
                  <Translate code={(lastQuestion && 'terminer') || 'continue'} />
                </button>
              )}
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  };
  if (display === 'loading' || hide === 'loading') {
    return (
      <div className="slide">
        <Flex {...props} headerTitle={headerTitle}>
          <div className="centered-loader">
            <Spinner color="primary" type="grow" />
          </div>
        </Flex>
      </div>
    );
  }

  return (
    <div className="slide">
      {!questionFullScreen && progress !== null && (
        <Progress className="progress-bar-images" value={progress} data-cy="progressBarImages">
          {progress}%
        </Progress>
      )}
      <Flex {...props} headerTitle={headerTitle} showSubHeader>
        <Container fluid className="mt-4">
          {!questionFullScreen && (
            <p className="text-primary h5" data-cy="questionTitle">
              <Translate code={question.id} /> {question.required ? '' : `(${t('optional')})`}
            </p>
          )}
          {question.label ? renderLabel() : ''}
        </Container>
        {renderElement()}

        {renderNav()}
      </Flex>
    </div>
  );
};

export default QuestionSlide;

QuestionSlide.propTypes = {
  id: PropTypes.number,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  calculateProgress: PropTypes.func.isRequired,
  lastQuestion: PropTypes.bool.isRequired,
  goPrevQuestion: PropTypes.func.isRequired,
  goNextQuestion: PropTypes.func.isRequired,
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    remove_if: PropTypes.bool,
    label: PropTypes.string,
    required: PropTypes.bool,
    type: PropTypes.string.isRequired,
    mask: PropTypes.string,
  }).isRequired,
  headerTitle: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};

QuestionSlide.defaultProps = {
  id: undefined,
};
